<template>
  <div class="room-admin-panel" :class="{ embedded: embedded }">
    <!-- 顶部标签 -->
    <div class="admin-tabs">
      <span class="admin-tab" :class="{ active: activeTab === 'post' }" @click="activeTab = 'post'">任职列表</span>
      <span class="admin-tab" :class="{ active: activeTab === 'ban' }" @click="activeTab = 'ban'">封禁名单</span>
      <span class="admin-tab" :class="{ active: activeTab === 'log' }" @click="activeTab = 'log'">操作记录</span>
    </div>

    <!-- 任职列表 -->
    <div v-if="activeTab === 'post'" class="tab-content">
      <div class="filter-bar">
        <div class="filter-item">
          <label>就任时间：</label>
          <input type="date" v-model="filters.startDate" placeholder="开始日期">
          <span class="sep">至</span>
          <input type="date" v-model="filters.endDate" placeholder="结束日期">
        </div>
        <div class="filter-item">
          <label>房间号：</label>
          <input type="text" v-model="filters.roomId" placeholder="">
        </div>
        <button class="search-btn" @click="handleSearch">搜索</button>
      </div>

      <div class="data-table-wrap">
        <table class="data-table">
          <thead>
            <tr>
              <th>房间号</th>
              <th>主播</th>
              <th>警告</th>
              <th>禁言</th>
              <th>解除禁言</th>
              <th>加入黑名单</th>
              <th>解除黑名单</th>
              <th>删评</th>
              <th>就任时间</th>
              <th>离任时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="11" class="loading-cell">加载中...</td>
            </tr>
            <tr v-else-if="postList.length === 0">
              <td colspan="11" class="empty-cell">暂无数据</td>
            </tr>
            <tr v-for="item in postList" :key="`${item.is_owner ? 'owner' : 'manager'}-${item.room_id}-${item.createtime}`">
              <td>{{ item.room_id }}</td>
              <td>{{ item.anchor_name || '-' }}</td>
              <td>{{ item.warn_count || 0 }}</td>
              <td>{{ item.ban_count || 0 }}</td>
              <td>{{ item.unban_count || 0 }}</td>
              <td>{{ item.black_add_count || 0 }}</td>
              <td>{{ item.black_remove_count || 0 }}</td>
              <td>{{ item.delete_count || 0 }}</td>
              <td>{{ formatTime(item.createtime) }}</td>
              <td>{{ item.leave_time ? formatTime(item.leave_time) : '-' }}</td>
              <td>
                <button v-if="item.is_owner || !item.leave_time" class="table-btn" @click="enterManage(item)">管理</button>
                <span v-else class="muted-text">已离任</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 封禁名单 -->
    <div v-if="activeTab === 'ban'" class="tab-content">
      <div class="filter-bar">
        <div class="filter-item">
          <label>房间号：</label>
          <input type="text" v-model="banFilters.roomId" placeholder="">
        </div>
        <button class="search-btn" @click="handleBanSearch">搜索</button>
      </div>
      <div class="data-table-wrap">
        <table class="data-table">
          <thead>
            <tr>
              <th>用户ID</th>
              <th>昵称</th>
              <th>房间号</th>
              <th>禁言原因</th>
              <th>禁言时长</th>
              <th>到期时间</th>
              <th>操作人</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="banLoading">
              <td colspan="8" class="loading-cell">加载中...</td>
            </tr>
            <tr v-else-if="banList.length === 0">
              <td colspan="8" class="empty-cell">暂无数据</td>
            </tr>
            <tr v-for="item in banList" :key="item.id">
              <td>{{ item.user_id }}</td>
              <td>{{ item.nickname || '用户' + item.user_id }}</td>
              <td>{{ item.room_id }}</td>
              <td>{{ item.reason || '-' }}</td>
              <td>{{ formatDuration(item.duration) }}</td>
              <td>{{ item.expiretime ? formatTime(item.expiretime) : '永久' }}</td>
              <td>{{ item.admin_name || '管理员' }}</td>
              <td>
                <button class="table-btn" @click="unban(item)">解除</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 操作记录 -->
    <div v-if="activeTab === 'log'" class="tab-content">
      <div class="filter-bar">
        <div class="filter-item">
          <label>操作时间：</label>
          <input type="date" v-model="logFilters.startDate">
          <span class="sep">至</span>
          <input type="date" v-model="logFilters.endDate">
        </div>
        <button class="search-btn" @click="handleLogSearch">搜索</button>
      </div>
      <div class="data-table-wrap">
        <table class="data-table">
          <thead>
            <tr>
              <th>时间</th>
              <th>房间号</th>
              <th>操作对象</th>
              <th>操作类型</th>
              <th>操作说明</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="logLoading">
              <td colspan="5" class="loading-cell">加载中...</td>
            </tr>
            <tr v-else-if="logList.length === 0">
              <td colspan="5" class="empty-cell">暂无数据</td>
            </tr>
            <tr v-for="item in logList" :key="item.id">
              <td>{{ formatTime(item.createtime) }}</td>
              <td>{{ item.room_id }}</td>
              <td>{{ item.target_name || item.target_id }}</td>
              <td>{{ item.action_name }}</td>
              <td>{{ item.remark || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 管理弹窗 -->
    <div v-if="showManage" class="modal-overlay" @click="showManage = false">
      <div class="modal-content" @click.stop>
        <h3 class="modal-title">房间 {{ manageRoomId }} 管理</h3>
        <div class="modal-tabs">
          <span v-if="manageIsOwner" :class="{ active: manageTab === 'manager' }" @click="manageTab = 'manager'">房管管理</span>
          <span :class="{ active: manageTab === 'ban' }" @click="manageTab = 'ban'">禁言用户</span>
        </div>

        <div v-if="manageTab === 'manager'" class="modal-body">
          <div class="add-row">
            <input type="number" v-model="newManagerId" placeholder="输入用户ID添加房管">
            <button class="search-btn" @click="handleAddManager">添加</button>
          </div>
          <div class="mini-list">
            <div class="mini-item" v-for="m in managers" :key="m.id">
              <span class="mini-name">{{ m.nickname || '用户' + m.user_id }}</span>
              <button class="mini-remove" @click="handleRemoveManager(m.user_id)">移除</button>
            </div>
            <div v-if="managers.length === 0" class="mini-empty">暂无房管</div>
          </div>
        </div>

        <div v-if="manageTab === 'ban'" class="modal-body">
          <div class="form-row">
            <label>用户ID</label>
            <input type="number" v-model="banForm.userId" placeholder="被禁言用户ID">
          </div>
          <div class="form-row">
            <label>禁言时长</label>
            <select v-model="banForm.duration">
              <option :value="10">10分钟</option>
              <option :value="60">1小时</option>
              <option :value="360">6小时</option>
              <option :value="1440">24小时</option>
              <option :value="0">永久</option>
            </select>
          </div>
          <div class="form-row">
            <label>禁言原因</label>
            <input type="text" v-model="banForm.reason" placeholder="选填">
          </div>
          <div class="modal-actions">
            <button class="cancel-btn" @click="showManage = false">取消</button>
            <button class="confirm-btn" @click="handleBan" :disabled="!banForm.userId">确认禁言</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { getRoomManagers, addRoomManager, removeRoomManager, banUser, unbanUser, getMyRooms, getBanList, getLogList } from '../api/roomManager';

export default {
  name: 'RoomAdminPanel',
  props: {
    embedded: { type: Boolean, default: false }
  },
  setup() {
    const activeTab = ref('post');
    const loading = ref(false);
    const banLoading = ref(false);
    const logLoading = ref(false);

    const filters = ref({ startDate: '', endDate: '', roomId: '' });
    const banFilters = ref({ roomId: '' });
    const logFilters = ref({ startDate: '', endDate: '' });

    const postList = ref([]);
    const banList = ref([]);
    const logList = ref([]);

    const showManage = ref(false);
    const manageRoomId = ref('');
    const manageIsOwner = ref(false);
    const manageTab = ref('manager');
    const managers = ref([]);
    const newManagerId = ref('');
    const banForm = ref({ userId: '', duration: 60, reason: '' });

    const formatTime = (ts) => {
      if (!ts) return '-';
      const num = Number(ts);
      if (isNaN(num)) return ts;
      return new Date(num * 1000).toLocaleString('zh-CN');
    };

    const formatDuration = (min) => {
      if (min === 0 || min === '0') return '永久';
      if (min < 60) return min + '分钟';
      if (min < 1440) return (min / 60).toFixed(0) + '小时';
      return (min / 1440).toFixed(0) + '天';
    };

    const handleSearch = async () => {
      loading.value = true;
      try {
        const res = await getMyRooms({
          start_date: filters.value.startDate,
          end_date: filters.value.endDate,
          room_id: filters.value.roomId
        });
        postList.value = res.code === 1 ? (res.data || []) : [];
      } catch (e) {
        postList.value = [];
      } finally {
        loading.value = false;
      }
    };

    const handleBanSearch = async () => {
      banLoading.value = true;
      try {
        const res = await getBanList({ room_id: banFilters.value.roomId });
        banList.value = res.code === 1 ? (res.data || []) : [];
      } catch (e) {
        banList.value = [];
      } finally {
        banLoading.value = false;
      }
    };

    const handleLogSearch = async () => {
      logLoading.value = true;
      try {
        const res = await getLogList({
          start_date: logFilters.value.startDate,
          end_date: logFilters.value.endDate
        });
        logList.value = res.code === 1 ? (res.data || []) : [];
      } catch (e) {
        logList.value = [];
      } finally {
        logLoading.value = false;
      }
    };

    const enterManage = async (item) => {
      const roomId = Number(item.room_id);
      manageRoomId.value = roomId;
      manageIsOwner.value = Boolean(Number(item.is_owner));
      manageTab.value = manageIsOwner.value ? 'manager' : 'ban';
      showManage.value = true;
      if (!manageIsOwner.value) {
        managers.value = [];
        return;
      }
      try {
        const res = await getRoomManagers(roomId);
        managers.value = res.code === 1 ? (res.data || []) : [];
      } catch (e) {
        managers.value = [];
      }
    };

    const handleAddManager = async () => {
      if (!newManagerId.value) return;
      try {
        const res = await addRoomManager(manageRoomId.value, newManagerId.value);
        if (res.code === 1) {
          alert('添加成功');
          newManagerId.value = '';
          await enterManage({ room_id: manageRoomId.value, is_owner: 1 });
        } else {
          alert(res.msg || '添加失败');
        }
      } catch (e) {
        alert(e.message || '添加失败');
      }
    };

    const handleRemoveManager = async (userId) => {
      if (!confirm('确定移除该房管？')) return;
      try {
        const res = await removeRoomManager(manageRoomId.value, userId);
        if (res.code === 1) {
          alert('移除成功');
          await enterManage({ room_id: manageRoomId.value, is_owner: 1 });
        } else {
          alert(res.msg || '移除失败');
        }
      } catch (e) {
        alert(e.message || '移除失败');
      }
    };

    const handleBan = async () => {
      if (!banForm.value.userId) return;
      try {
        const res = await banUser(manageRoomId.value, banForm.value.userId, banForm.value.reason, banForm.value.duration);
        if (res.code === 1) {
          alert('禁言成功');
          banForm.value.userId = '';
          banForm.value.reason = '';
        } else {
          alert(res.msg || '禁言失败');
        }
      } catch (e) {
        alert(e.message || '禁言失败');
      }
    };

    const unban = async (item) => {
      if (!confirm('确定解除该用户禁言？')) return;
      try {
        const res = await unbanUser(item.room_id, item.user_id);
        if (res.code === 1) {
          alert('解除禁言成功');
          await handleBanSearch();
        } else {
          alert(res.msg || '操作失败');
        }
      } catch (e) {
        alert(e.message || '操作失败');
      }
    };

    onMounted(() => {
      handleSearch();
    });

    return {
      activeTab, loading, banLoading, logLoading,
      filters, banFilters, logFilters,
      postList, banList, logList,
      showManage, manageRoomId, manageIsOwner, manageTab, managers, newManagerId, banForm,
      handleSearch, handleBanSearch, handleLogSearch,
      enterManage, handleAddManager, handleRemoveManager, handleBan, unban,
      formatTime, formatDuration
    };
  }
};
</script>

<style scoped>
.room-admin-panel {
  padding: 20px;
}
.room-admin-panel.embedded {
  padding: 20px 24px;
}

/* 顶部标签 */
.admin-tabs {
  display: flex;
  gap: 24px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 24px;
}
.admin-tab {
  padding: 10px 4px;
  font-size: 15px;
  color: #666;
  cursor: pointer;
  position: relative;
  transition: color 0.2s;
}
.admin-tab:hover {
  color: #ff6a00;
}
.admin-tab.active {
  color: #ff6a00;
  font-weight: 700;
}
.admin-tab.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #ff6a00, #ff9600);
  border-radius: 2px 2px 0 0;
}

/* 筛选栏 */
.filter-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: #fafafa;
  border-radius: 8px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.filter-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.filter-item label {
  font-size: 13px;
  color: #666;
  white-space: nowrap;
}
.filter-item input {
  padding: 7px 10px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  font-size: 13px;
  outline: none;
}
.filter-item input:focus {
  border-color: #ff9600;
}
.sep {
  font-size: 13px;
  color: #999;
}
.search-btn {
  padding: 8px 22px;
  border: none;
  border-radius: 4px;
  background: #ff9600;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.search-btn:hover {
  background: #ff6a00;
}
.search-btn:disabled {
  opacity: 0.6;
}

/* 表格 */
.data-table-wrap {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.data-table th {
  background: #fafafa;
  padding: 12px 8px;
  color: #666;
  font-weight: 600;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
}
.data-table td {
  padding: 14px 8px;
  text-align: center;
  color: #333;
  border-bottom: 1px solid #f5f5f5;
}
.data-table tbody tr:last-child td {
  border-bottom: none;
}
.data-table tbody tr:hover {
  background: #fafafa;
}
.loading-cell,
.empty-cell {
  padding: 40px !important;
  color: #999;
}
.table-btn {
  padding: 4px 12px;
  border: 1px solid #ff9600;
  border-radius: 4px;
  background: #fff;
  color: #ff9600;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}
.table-btn:hover {
  background: #ff9600;
  color: #fff;
}

/* 弹窗 */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.modal-content {
  background: #fff;
  border-radius: 12px;
  width: 480px;
  max-width: 90%;
  padding: 24px;
}
.modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin: 0 0 16px;
}
.modal-tabs {
  display: flex;
  gap: 16px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 16px;
}
.modal-tabs span {
  padding: 8px 4px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
}
.modal-tabs span.active {
  color: #ff6a00;
  font-weight: 700;
  border-bottom: 2px solid #ff9600;
}
.modal-body {
  padding: 8px 0;
}
.add-row {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
}
.add-row input {
  flex: 1;
  padding: 9px 12px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
}
.mini-list {
  max-height: 240px;
  overflow-y: auto;
}
.mini-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f5f5f5;
}
.mini-name {
  font-size: 14px;
  color: #333;
}
.mini-remove {
  padding: 3px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  color: #999;
  font-size: 12px;
  cursor: pointer;
}
.mini-remove:hover {
  border-color: #ef4444;
  color: #ef4444;
}
.mini-empty {
  padding: 20px 0;
  text-align: center;
  color: #999;
  font-size: 13px;
}
.form-row {
  margin-bottom: 14px;
}
.form-row label {
  display: block;
  font-size: 13px;
  color: #666;
  margin-bottom: 6px;
}
.form-row input,
.form-row select {
  width: 100%;
  padding: 9px 12px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
}
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
.cancel-btn {
  padding: 8px 18px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  color: #666;
  cursor: pointer;
}
.confirm-btn {
  padding: 8px 18px;
  border: none;
  border-radius: 4px;
  background: #ff9600;
  color: #fff;
  cursor: pointer;
}
.confirm-btn:disabled {
  opacity: 0.5;
}

@media (max-width: 768px) {
  .admin-tabs {
    gap: 16px;
  }
  .filter-bar {
    flex-direction: column;
    align-items: flex-start;
  }
  .data-table {
    font-size: 12px;
  }
  .data-table th,
  .data-table td {
    padding: 10px 4px;
  }
}
</style>
